var _path, _g, _path2, _path3, _path4, _path5, _path6, _g2, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 184,
    height: 184,
    viewBox: "0 0 184 184",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M92.0004 164.987C132.649 164.987 165.6 132.035 165.6 91.3871C165.6 50.7389 132.649 17.7871 92.0004 17.7871C51.3522 17.7871 18.4004 50.7389 18.4004 91.3871C18.4004 132.035 51.3522 164.987 92.0004 164.987Z",
    fill: "url(#paint0_linear_84_1088)"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_84_1088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.156 38.9824H64.4002C58.9805 38.9824 54.5869 43.376 54.5869 48.7958V124.253C54.5869 129.673 58.9805 134.067 64.4002 134.067H121.156C126.576 134.067 130.97 129.673 130.97 124.253V48.7958C130.97 43.376 126.576 38.9824 121.156 38.9824Z",
    fill: "url(#paint1_linear_84_1088)"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9954 51.25H64.3393C62.6795 51.25 61.334 52.5955 61.334 54.2553V54.2553C61.334 55.9151 62.6795 57.2607 64.3393 57.2607H88.9954C90.6552 57.2607 92.0007 55.9151 92.0007 54.2553C92.0007 52.5955 90.6552 51.25 88.9954 51.25Z",
    fill: "#771117"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M119.662 68.3008H64.3393C62.6795 68.3008 61.334 69.6463 61.334 71.3061V71.3061C61.334 72.9659 62.6795 74.3115 64.3393 74.3115H119.662C121.322 74.3115 122.667 72.9659 122.667 71.3061C122.667 69.6463 121.322 68.3008 119.662 68.3008Z",
    fill: "#D5D5D5"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M119.662 85.3516H64.3393C62.6795 85.3516 61.334 86.6971 61.334 88.3569V88.3569C61.334 90.0167 62.6795 91.3622 64.3393 91.3622H119.662C121.322 91.3622 122.667 90.0167 122.667 88.3569C122.667 86.6971 121.322 85.3516 119.662 85.3516Z",
    fill: "#D5D5D5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M119.662 102.402H64.3393C62.6795 102.402 61.334 103.748 61.334 105.407V105.407C61.334 107.067 62.6795 108.413 64.3393 108.413H119.662C121.322 108.413 122.667 107.067 122.667 105.407C122.667 103.748 121.322 102.402 119.662 102.402Z",
    fill: "#D5D5D5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M119.662 119.453H64.3393C62.6795 119.453 61.334 120.799 61.334 122.458V122.458C61.334 124.118 62.6795 125.464 64.3393 125.464H119.662C121.322 125.464 122.667 124.118 122.667 122.458C122.667 120.799 121.322 119.453 119.662 119.453Z",
    fill: "#D5D5D5"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_84_1088)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M176.732 28.4746H139.883C138.165 28.4746 136.773 29.9396 136.773 31.7467V49.9744C136.773 51.7815 138.165 53.2465 139.883 53.2465H176.732C178.449 53.2465 179.841 51.7815 179.841 49.9744V31.7467C179.841 29.9396 178.449 28.4746 176.732 28.4746Z",
    fill: "white"
  }))), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M145.974 44.7741C148.006 44.7741 149.654 43.1265 149.654 41.0941C149.654 39.0617 148.006 37.4141 145.974 37.4141C143.942 37.4141 142.294 39.0617 142.294 41.0941C142.294 43.1265 143.942 44.7741 145.974 44.7741Z",
    fill: "#E8D8D9"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M170.508 37.4141H158.241C156.209 37.4141 154.561 39.0617 154.561 41.0941C154.561 43.1265 156.209 44.7741 158.241 44.7741H170.508C172.54 44.7741 174.188 43.1265 174.188 41.0941C174.188 39.0617 172.54 37.4141 170.508 37.4141Z",
    fill: "#D5D5D5"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M113.534 138.346C121.434 138.346 128.776 135.957 134.876 131.861L159.838 155.69L168.891 145.187L144.803 122.193C149.252 115.932 151.868 108.278 151.868 100.013C151.868 78.8421 134.705 61.6797 113.534 61.6797C92.3636 61.6797 75.2012 78.8421 75.2012 100.013C75.2012 121.184 92.3636 138.346 113.534 138.346ZM146.23 100.012C146.23 117.935 131.7 132.465 113.777 132.465C95.8534 132.465 81.3235 117.935 81.3235 100.012C81.3235 82.0884 95.8534 67.5585 113.777 67.5585C131.7 67.5585 146.23 82.0884 146.23 100.012Z",
    fill: "#E8D8D9"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    d: "M113.773 133.094C132.234 133.094 147.2 118.265 147.2 99.9735C147.2 81.6818 132.234 66.8535 113.773 66.8535C95.3123 66.8535 80.3467 81.6818 80.3467 99.9735C80.3467 118.265 95.3123 133.094 113.773 133.094Z",
    fill: "white",
    fillOpacity: 0.3
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    d: "M119.553 99.974L127.643 91.916C128.4 91.1189 128.816 90.0594 128.8 88.9628C128.784 87.8662 128.339 86.8189 127.559 86.0434C126.779 85.2679 125.725 84.8254 124.622 84.8098C123.518 84.7943 122.452 85.207 121.65 85.9602L113.543 94.0181L105.454 85.9602C105.065 85.5508 104.597 85.223 104.078 84.9965C103.559 84.7699 102.999 84.649 102.433 84.641C101.866 84.6331 101.303 84.7381 100.778 84.95C100.253 85.1619 99.7761 85.4763 99.3753 85.8746C98.9746 86.2729 98.6582 86.7471 98.4451 87.2691C98.2319 87.791 98.1262 88.3502 98.1342 88.9134C98.1422 89.4767 98.2638 90.0326 98.4918 90.5484C98.7198 91.0641 99.0495 91.5292 99.4614 91.916L107.564 99.974L99.4614 108.032C99.0495 108.419 98.7198 108.884 98.4918 109.4C98.2638 109.915 98.1422 110.471 98.1342 111.034C98.1262 111.598 98.2319 112.157 98.4451 112.679C98.6582 113.201 98.9746 113.675 99.3753 114.073C99.7761 114.472 100.253 114.786 100.778 114.998C101.303 115.21 101.866 115.315 102.433 115.307C102.999 115.299 103.559 115.178 104.078 114.951C104.597 114.725 105.065 114.397 105.454 113.988L113.561 105.93L121.668 113.988C122.478 114.697 123.529 115.072 124.607 115.037C125.686 115.002 126.71 114.56 127.472 113.801C128.234 113.041 128.676 112.022 128.707 110.95C128.739 109.878 128.358 108.834 127.643 108.032L119.553 99.974Z",
    fill: "#771117"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M159.836 155.689L168.889 145.186L170.252 146.488C171.575 147.751 172.368 149.515 172.454 151.392C172.541 153.27 171.916 155.107 170.716 156.499C169.516 157.892 167.84 158.725 166.056 158.817C164.271 158.908 162.526 158.25 161.203 156.987L159.839 155.685L159.836 155.689Z",
    fill: "#F2E0E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M34.5401 55.9201C34.5286 55.0455 34.4189 54.1633 34.1994 53.2751C33.4299 50.1581 29.9965 48.157 26.3423 47.6865C22.6895 47.216 18.8908 48.2867 17.4268 50.998C16.5894 52.5483 16.4739 53.8843 16.8161 55.0108C17.1568 56.1312 17.9653 57.0601 19.0626 57.784C22.122 59.8002 27.48 60.2118 29.9244 59.3689C31.0548 58.9783 32.1593 58.5078 33.2349 57.9695C32.6199 61.4937 30.3286 64.8323 27.2706 67.8408C20.6248 74.3794 10.3118 79.3422 4.69541 81.1668C4.39366 81.2648 4.22616 81.5996 4.32001 81.9148C4.41386 82.2299 4.73437 82.4064 5.03613 82.3084C10.7637 80.4475 21.2774 75.3792 28.0546 68.7109C31.5558 65.2666 34.0507 61.3896 34.4766 57.3135C42.3915 52.8966 48.8915 44.8832 54.4487 38.1395C54.6551 37.8907 54.6277 37.5121 54.388 37.2965C54.1484 37.0824 53.7874 37.1095 53.5809 37.3598C48.2504 43.8276 42.0638 51.5213 34.5401 55.9201ZM33.3895 56.561C33.4328 55.5778 33.3403 54.5795 33.0906 53.5722C32.425 50.8744 29.3656 49.279 26.2022 48.8718C24.2632 48.623 22.2693 48.8281 20.7057 49.5579C19.7225 50.0164 18.9125 50.6814 18.4245 51.5862C17.7834 52.773 17.6448 53.7878 17.9076 54.6489C18.1703 55.516 18.823 56.2127 19.6734 56.7721C22.4614 58.6104 27.3399 59.001 29.5648 58.2334C30.8772 57.781 32.1507 57.217 33.3895 56.561Z",
    fill: "#771117"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M174.8 116.534C176.833 116.534 178.48 114.886 178.48 112.854C178.48 110.822 176.833 109.174 174.8 109.174C172.768 109.174 171.12 110.822 171.12 112.854C171.12 114.886 172.768 116.534 174.8 116.534Z",
    fill: "#E3E3E3"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M35.8093 138.242C36.4661 137.996 37.1572 137.669 37.6901 137.195C38.3231 136.632 38.5805 135.907 38.7534 135.144C38.9753 134.164 39.064 133.12 39.3331 132.138C39.4327 131.773 39.6245 131.635 39.7068 131.574C39.9147 131.419 40.1249 131.378 40.3227 131.394C40.5571 131.412 40.8791 131.505 41.0908 131.918C41.121 131.978 41.1603 132.068 41.1867 132.191C41.2059 132.282 41.2184 132.565 41.2388 132.682C41.2897 132.969 41.3324 133.257 41.3724 133.546C41.5056 134.509 41.5822 135.326 42.0031 136.21C42.5741 137.411 43.1463 138.145 43.9223 138.47C44.6727 138.785 45.5698 138.726 46.7161 138.479C46.8252 138.451 46.9331 138.428 47.0399 138.408C47.5453 138.315 48.0285 138.664 48.1277 139.194C48.227 139.724 47.9058 140.24 47.4049 140.356C47.3004 140.38 47.1973 140.403 47.0954 140.424C45.5464 140.828 43.7532 142.268 42.7111 143.529C42.3899 143.918 41.9197 145.005 41.4399 145.699C41.0859 146.211 40.6881 146.548 40.3541 146.667C40.1302 146.747 39.9415 146.735 39.7856 146.694C39.5592 146.636 39.3712 146.506 39.227 146.301C39.1485 146.189 39.0757 146.038 39.0409 145.846C39.0243 145.753 39.0225 145.518 39.0228 145.412C38.9251 145.058 38.8054 144.712 38.7182 144.355C38.5103 143.503 38.1023 142.964 37.6176 142.251C37.1643 141.584 36.6775 141.165 35.9637 140.831C35.8709 140.807 35.1217 140.614 34.8571 140.503C34.4706 140.341 34.2864 140.068 34.2196 139.922C34.106 139.673 34.0943 139.456 34.1169 139.275C34.1505 139.007 34.2645 138.779 34.4668 138.594C34.5921 138.479 34.7793 138.368 35.03 138.313C35.2236 138.271 35.7372 138.246 35.8093 138.242ZM40.2046 136.854C40.2393 136.935 40.2763 137.017 40.3156 137.1C41.152 138.858 42.0872 139.839 43.2241 140.315L43.2622 140.331C42.5017 140.925 41.8132 141.589 41.2871 142.226C41.0704 142.488 40.7836 143.033 40.4737 143.591C40.1921 142.628 39.7317 141.947 39.1527 141.095C38.7103 140.445 38.2468 139.956 37.6773 139.557C38.1193 139.318 38.5409 139.038 38.9081 138.712C39.5195 138.168 39.9238 137.538 40.2046 136.854Z",
    fill: "#E8D8D9"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_84_1088",
    x: 54.5869,
    y: 38.9824,
    width: 76.3828,
    height: 115.084,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 20
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 15
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0 0.570833 0 0 0 0.19 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_84_1088"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_84_1088",
    x: 136.773,
    y: 28.4746,
    width: 46.7481,
    height: 27.2252,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 3.68,
    dy: 2.45333
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.98667
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.104618 0 0 0 0 0.465612 0 0 0 0 0.545833 0 0 0 0.09 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_84_1088"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_84_1088",
    x1: 91.433,
    y1: -6.17885,
    x2: 92.9407,
    y2: 252.293,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F2F2F2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#EFEFEF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_84_1088",
    x1: 92.7783,
    y1: 38.9824,
    x2: 92.7783,
    y2: 134.067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71875,
    stopColor: "#FAFAFA"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.76902143d04718d4360122b3c926586f.svg";
export { ForwardRef as ReactComponent };